// extracted by mini-css-extract-plugin
export var active = "_s2-1";
export var circle = "_s2-0";
export var completed = "_s2-2";
export var connector = "_s2-4";
export var connectorCompleted = "_s2-7";
export var connectorSpacer = "_s2-5";
export var iconStrokeOverride = "_s2-8";
export var labelContainer = "_s2-6";
export var pending = "_s2-3";